// Predefined palette of soft, distinct colors suitable for backgrounds with dark text
export const GENETIC_PALETTE = [
    '#F4BEBE',
    '#FBE0DF',
    '#FBBEB6',
    '#FAE5E1',
    '#F7C8BA',
    '#FDE7DD',
    '#F4D1BE',
    '#FBEBDF',
    '#FBD6B6',
    '#FAEEE1',
    '#F7DFBA',
    '#FDF2DD',
    '#F4E4BE',
    '#FBF5DF',
    '#FBF0B6',
    '#FAF7E1',
    '#F7F4BA',
    '#FDFDDD',
    '#F0F4BE',
    '#F8FBDF',
    '#EDFBB6',
    '#F3FAE1',
    '#E4F7BA',
    '#F1FDDD',
    '#DCF4BE',
    '#EDFBDF',
    '#D5FBB6',
    '#EAFAE1',
    '#CFF7BA',
    '#E6FDDD',
    '#C9F4BE',
    '#E3FBDF',
    '#BCFBB6',
    '#E1FAE1',
    '#BAF7BC',
    '#DDFDE0',
    '#BEF4C6',
    '#DFFBE5',
    '#B6FBC9',
    '#E1FAE9',
    '#BAF7D3',
    '#DDFDEC',
    '#BEF4DA',
    '#DFFBEF',
    '#B6FBE2',
    '#E1FAF2',
    '#BAF7E8',
    '#DDFDF7',
    '#BEF4EC',
    '#DFFBFA',
    '#B6FBFB',
    '#E1F8FA',
    '#BAF0F7',
    '#DDF8FD',
    '#BEE7F4',
    '#DFF3FB',
    '#B6E3FB',
    '#E1EFFA',
    '#BADBF7',
    '#DDECFD',
    '#BED3F4',
    '#DFE9FB',
    '#B6CAFB',
    '#E1E6FA',
    '#BAC4F7',
    '#DDE0FD',
    '#BEC1F4',
    '#DFDFFB',
    '#BBB6FB',
    '#E4E1FA',
    '#C6BAF7',
    '#E5DDFD',
    '#CFBEF4',
    '#E9DFFB',
    '#D4B6FB',
    '#EDE1FA',
    '#DCBAF7',
    '#F1DDFD',
    '#E2BEF4',
    '#F4DFFB',
    '#EDB6FB',
    '#F6E1FA',
    '#F2BAF7',
    '#FCDDFD',
    '#F4BEF2',
    '#FBDFF9',
    '#FBB6F1',
    '#FAE1F4',
    '#F7BAE7',
    '#FDDDF3',
    '#F4BEDE',
    '#FBDFEF',
    '#FBB6D8',
    '#FAE1EB',
    '#F7BAD1',
    '#FDDDE7',
    '#F4BECB',
    '#FBDFE4',
    '#FBB6C0',
    '#FAE1E2',
];

const BORDER_PALETTE = [
    '#DD3C3C',
    '#EC5D55',
    '#F43D25',
    '#E3755F',
    '#E85B30',
    '#F67F4C',
    '#DD743C',
    '#EC9455',
    '#F48525',
    '#E3A55F',
    '#E89F30',
    '#F6BA4C',
    '#DDAF3C',
    '#ECC955',
    '#F4D125',
    '#E3D55F',
    '#E8DF30',
    '#F3F64C',
    '#D2DD3C',
    '#D8EC55',
    '#CAF425',
    '#C2E35F',
    '#AEE830',
    '#B7F64C',
    '#97DD3C',
    '#A1EC55',
    '#82F425',
    '#91E35F',
    '#6EE830',
    '#79F64C',
    '#5CDD3C',
    '#6CEC55',
    '#36F425',
    '#63E35F',
    '#30E837',
    '#4CF65D',
    '#3CDD54',
    '#55EC76',
    '#25F45C',
    '#5FE38B',
    '#30E87A',
    '#4CF698',
    '#3CDD8F',
    '#55ECAB',
    '#25F4A8',
    '#5FE3BB',
    '#30E8BA',
    '#4CF6D6',
    '#3CDDC7',
    '#55ECE2',
    '#25F4F4',
    '#5FDCE3',
    '#30D3E8',
    '#4CD9F6',
    '#3CB7DD',
    '#55BFEC',
    '#25ABF4',
    '#5FACE3',
    '#3092E8',
    '#4C9BF6',
    '#3C7CDD',
    '#558AEC',
    '#255FF4',
    '#5F7DE3',
    '#304FE8',
    '#4C5DF6',
    '#3C44DD',
    '#5855EC',
    '#3325F4',
    '#705FE3',
    '#5530E8',
    '#764CF6',
    '#6F3CDD',
    '#8D55EC',
    '#7E25F4',
    '#A15FE3',
    '#9530E8',
    '#B44CF6',
    '#A73CDD',
    '#C455EC',
    '#CA25F4',
    '#CF5FE3',
    '#D930E8',
    '#F04CF6',
    '#DD3CD7',
    '#EC55DD',
    '#F425D5',
    '#E35FC6',
    '#E830B7',
    '#F64CBD',
    '#DD3C9C',
    '#EC55A8',
    '#F42589',
    '#E35F98',
    '#E83074',
    '#F64C7F',
    '#DD3C64',
    '#EC5571',
    '#F42541',
    '#E35F67',
];



export const getGeneticColor = (name?: string, dbColor?: string) => {
    if (dbColor) return { bg: dbColor, border: dbColor };
    if (!name) return { bg: '#F0FFF4', border: '#48BB78' }; // Default Green

    let hash = 5381;
    for (let i = 0; i < name.length; i++) {
        // DJB2 hash variant
        hash = ((hash << 5) + hash) + name.charCodeAt(i); /* hash * 33 + c */
    }

    const index = Math.abs(hash) % GENETIC_PALETTE.length;
    return {
        bg: GENETIC_PALETTE[index],
        border: BORDER_PALETTE[index] || BORDER_PALETTE[index % BORDER_PALETTE.length]
    };
};

export const generateUniqueColor = (existingColors: string[]): string => {
    const used = new Set(existingColors.map(c => c?.toUpperCase()));

    // 1. Try to find an unused color from our predefined beautiful palette
    const shuffledPalette = [...GENETIC_PALETTE].sort(() => 0.5 - Math.random());
    for (const color of shuffledPalette) {
        if (!used.has(color.toUpperCase())) {
            return color;
        }
    }

    // 2. If all predefined colors are used, safely fallback to a random pleasant hex color
    let randomColor;
    do {
        // Generate a lighter color suitable for backgrounds
        const r = Math.floor(Math.random() * 127 + 128).toString(16).padStart(2, '0');
        const g = Math.floor(Math.random() * 127 + 128).toString(16).padStart(2, '0');
        const b = Math.floor(Math.random() * 127 + 128).toString(16).padStart(2, '0');
        randomColor = `#${r}${g}${b}`.toUpperCase();
    } while (used.has(randomColor));

    return randomColor;
};
